import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FeaturesRecommendationComponent } from '../../../features-management/features-recommendation/features-recommendation.component';
import { CustomDialogWindowComponent } from '../custom-dialog-window/custom-dialog-window.component';
import { DeleteDialogWindowComponent } from '../delete-dialog-window/delete-dialog-window.component';
import { CustomDialogWindow } from '../shared/custom-dialog-window';
import { WarnDialogWindowComponent } from '../warn-dialog-window/warn-dialog-window.component';
import { QuickCiteDialogComponent } from '../../../quick-cite/quick-cite-dialog/quick-cite-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(private modal: BsModalService) {}

  openDeleteDialog(msg: string, onConfirm: () => void, onCancel: () => void = () => {}) {
    this.modal.show(DeleteDialogWindowComponent, {
      initialState: {
        title: 'winDialog.delete',
        message: msg,
        confirm: onConfirm,
        cancel: onCancel
      }
    });
  }

  openWarnDialog(message: string, warnTitle: string, onClose: () => void) {
    this.modal.show(WarnDialogWindowComponent, {
      initialState: {
        warnTitle: warnTitle,
        message: message,
        close: onClose
      }
    });
  }

  openRecommenddedFeatureDialog = () => this.modal.show(FeaturesRecommendationComponent, Object.assign({}, { class: 'sectioned-modal  wide-modal' }));

  openDialog(dialog: CustomDialogWindow) {
    this.modal.show(CustomDialogWindowComponent, {
      initialState: {
        dialog: dialog
      }
    });
  }

  openQuickCiteDialog(citationId: any) {
    this.modal.show(QuickCiteDialogComponent, {
      initialState: {
        citationId: citationId
      }
    });
  }
}
